/* eslint formatjs/no-literal-string-in-jsx: "error" */
import { ICategory, ISubCategory } from "../../contentful-types"
import { Container, FlexContainer, Text, SimpleGrid, Divider, ArrowLink } from "@carrotfertility/carotene"
import ArticleThumbnail from "./ArticleThumbnail"
import React from "react"
import { useContentfulConditionalGate } from "../../lib/contentful/components/ContentfulConditionGate"
import slugify from "slugify"
import { useReadLearnLinks } from "./shared/ReadLearnLinks"
import { useWindowEvent } from "../../utils/hooks/useWindowEvent"
import { FormattedMessage } from "react-intl"

type SubcategorySectionProps = {
  subCategory: ISubCategory
  category: ICategory
  isLast: boolean
}

export function SubcategorySection({ subCategory, category, isLast }: SubcategorySectionProps): JSX.Element {
  const { subCategoryPageLink } = useReadLearnLinks({ category, subCategory })
  const [windowWidth, setWindowWidth] = React.useState({
    width: window.innerWidth
  })
  const maxNumOfVisibleArticles = 6

  const handleResize = () => {
    setWindowWidth({
      width: window.innerWidth
    })
  }

  useWindowEvent("resize", handleResize)
  const articleAndConditions = React.useMemo(
    () =>
      subCategory?.fields?.articles?.map((article) => ({
        element: (
          <ArticleThumbnail
            key={article?.sys?.id}
            contentType={article?.sys?.contentType?.sys?.id}
            article={article}
            category={category}
          />
        ),
        conditions: article?.fields?.conditions
      })),
    [category, subCategory?.fields?.articles]
  )
  const filteredArticles = useContentfulConditionalGate(articleAndConditions)

  const getStackSpacing = (): string => {
    if (isLast) return "none"
    return filteredArticles.length > maxNumOfVisibleArticles ? "large" : "huge"
  }

  return (
    <Container id={slugify(subCategory.fields.navTitle ?? subCategory.fields.title)}>
      <Divider paddingTopBottom="tiny" stack="small" />
      <FlexContainer stack={"medium"} direction={"row"} justifyContent={"space-between"}>
        <Text weight={"semibold"} color={"black60"}>
          {subCategory.fields.title}
        </Text>
      </FlexContainer>
      <Container stack={getStackSpacing()}>
        <SimpleGrid columns={[1, 1, 1, windowWidth.width < 1200 ? 2 : 3]} spacing={"32px"}>
          {filteredArticles.slice(0, maxNumOfVisibleArticles)}
        </SimpleGrid>
        <FlexContainer justifyContent="flex-end" padding="24px 0 0 0">
          {filteredArticles.length > maxNumOfVisibleArticles ? (
            <ArrowLink to={subCategoryPageLink}>
              <FormattedMessage
                defaultMessage="See all {articleCount, number} resources"
                values={{ articleCount: filteredArticles.length }}
              />
            </ArrowLink>
          ) : null}
        </FlexContainer>
      </Container>
    </Container>
  )
}
